module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1011.b53165bf.png";